import { Injectable } from '@angular/core';
import { OfbizField } from './ofbiz-form-model';

@Injectable({
  providedIn: 'root'
})
export class FormErrorServicesService {

  constructor() { }

  checkFormFieldErrors(fields:any[],formName){
    fields.forEach((field:OfbizField) => {
      let type = field.type;
      switch (type) {
        case "hyperlink":
        case "HYPERLINK":
          this.checkHyperLinkFieldErrors(field,formName);
          break;
        case "display-entity":
        case "DISPLAY_ENTITY":
          this.checkDisplayFieldErrors(field,formName)
          break;
        case "drop-down":
        case "DROP_DOWN":
          this.checkDropDownFieldErrors()
          break;
        case "image":
        case "IMAGE":
          this.checkImageFieldErrors()          
          break;
        case "check":
        case "CHECK":
          this.checkCheckBoxFieldErrors()          
          break;
        case "input":
        case "INPUT":
        case "Input":
          this.checkInputFieldErrors()
          break;
        case "sequence":
        case "SEQUENCE":
          this.checkSequenceFieldErrors()
          break;
        case "COMPOSITE":
        case "composite":
          this.checkCompositeFieldErrors()
          break;
        default:
          break;
      }
    })
  }

  checkHyperLinkFieldErrors(field:OfbizField,formName:string){
    try{
      this.hyperLinkFieldMissingFormData(field,"formData");
      this.hyperLinkFieldMissingFormData(field,"event")
    }catch(error){
      console.log(error, formName,field.name)
    }
  }
  checkDisplayFieldErrors(field:OfbizField,formName:string){
    if(field.hyperlink){
      console.log(field)
      try{
          this.checkNestedProperty(field.hyperlink,"remoteFormData")
          this.checkLinkFormData(field,"event")
      }catch(error){
          console.log(error, formName,field.name)
      }
      
    }
  }
  checkDropDownFieldErrors(){}
  checkImageFieldErrors(){}
  checkCheckBoxFieldErrors(){}
  checkInputFieldErrors(){}
  checkSequenceFieldErrors(){}
  checkCompositeFieldErrors(){}

  hyperLinkFieldMissingFormData<T extends object, K extends keyof T>(obj: T, key: K): void {
      if (!(key in obj) || obj[key] === null || obj[key] === undefined) {
          throw new FormFormattingError(`Property "${String(key)}" is missing or has an invalid value.`,obj);
      }
  }

  checkNestedProperty<T extends object, K extends keyof T>(obj: T, key: K): void {
    console.log(obj)
    if (!obj?.[key] || obj[key] === null || obj[key] === undefined) {
      throw new FormFormattingError(`Property "${String(key)}" is missing or invalid.`,obj);
    }
  }

  checkLinkFormData<T extends object, K extends keyof T>(obj: T, key: K): void {
      if (!(key in obj) || obj[key] === null || obj[key] === undefined) {
          throw new FormFormattingError(`Property "${String(key)}" is missing or has an invalid value.`,obj);
      }
  }

  

}

export class FormFormattingError extends Error{
  constructor(message:string,obj?:any){
      super(message);
      this.name = "FormFormattingError"
  }
}


